import type { Validity } from 'types/common/validationTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type CoverageAmountSuppliersState = {
  fetching: FetchingStatus | null;
  validity: Validity | null;
  value: string[] | null;
};

const initialState: CoverageAmountSuppliersState = {
  fetching: null,
  validity: null,
  value: null,
};

function setFetchingFunction(
  state: CoverageAmountSuppliersState,
  action: PayloadAction<CoverageAmountSuppliersState['fetching']>
) {
  return {
    ...state,
    fetching: action.payload,
  };
}

function setValidityFunction(
  state: CoverageAmountSuppliersState,
  action: PayloadAction<CoverageAmountSuppliersState['validity']>
) {
  return {
    ...state,
    validity: action.payload,
  };
}

function setCoverageAmountSuppliersFunction(
  state: CoverageAmountSuppliersState,
  action: PayloadAction<CoverageAmountSuppliersState['value']>
) {
  return {
    ...state,
    value: action.payload,
  };
}

const slice = createSlice({
  name: 'coverageAmountSuppliers',
  initialState,
  reducers: {
    setFetching: setFetchingFunction,
    setValidity: setValidityFunction,
    setCoverageAmountSuppliers: setCoverageAmountSuppliersFunction,
  },
});

export const { setFetching, setValidity, setCoverageAmountSuppliers } = slice.actions;
export default slice.reducer;
